import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=6c4b1007&scoped=true"
import script from "./RelatedArticles.vue?vue&type=script&lang=ts"
export * from "./RelatedArticles.vue?vue&type=script&lang=ts"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=6c4b1007&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b1007",
  null
  
)

export default component.exports